module.exports = __webpack_public_path__ + "img/icon10.9c01f68f.svg";